















































































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientPowerOfAttorney, createClientPowerOfAttorney } from '@/shared/clients/client-power-of-attorney';
import { PowerOfAttorneyType } from '@/shared/types/power-of-attorney-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

@Component
export default class AddPowerOfAttorney extends Vue {
    @typesModule.Getter('activePowerOfAttorneyTypes') private powerOfAttorneyTypes!: Array<PowerOfAttorneyType>;

    @Prop({ required: true }) private visible!: boolean;
    @Prop({ required: true }) private client!: ClientAccount;

    private isVisible: boolean = this.visible;
    private clientPowerOfAttorney: ClientPowerOfAttorney = createClientPowerOfAttorney();

    private get filteredPowerOfAttorneyTypes(): Array<PowerOfAttorneyType> {
        if (!this.powerOfAttorneyTypes.length) {
            return [];
        }

        const result = [];

        for (const type of this.powerOfAttorneyTypes) {
            if (type.isUnknown || (type.isExclusive && this.client.powerOfAttorneys.some((poa) => poa.powerOfAttorneyTypeId === type.id))) {
                continue;
            }

            result.push({ ...type });
        }

        return result;
    }

    @Watch('visible')
    private onVisibleChanged(value: boolean): void {
        this.isVisible = value;
    }

    private async onSave(): Promise<void> {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
            return;
        }

        try {
            this.$emit('ok', { ...this.clientPowerOfAttorney }, false);
        } catch (e) {
            this.$snackbar.open({ message: `Could not create power of attorney. Please try again.`, type: 'is-danger' });
        }
    }

    private async onSaveAndAddAnother(): Promise<void> {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
            return;
        }

        try {
            this.$emit('ok', { ...this.clientPowerOfAttorney }, true);
            this.reset();
        } catch (e) {
            this.$snackbar.open({ message: `Could not create power of attorney. Please try again.`, type: 'is-danger' });
        }
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private reset(): void {
        this.clientPowerOfAttorney = createClientPowerOfAttorney();
        this.$validator.errors.clear();
    }
}
